import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Copy, FloaterTooltipMarkdown, Icon } from '@honda-canada/design-system-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Superscript from '../shared/Superscript';
import themeStyles from '../styles/PaymentTabs.styles';
import SpecialOfferIcon from './SpecialOfferIcon';
const AvailableOfferContainer = themeStyles.apply(Box, 'AvailableOfferContainer');
const AvailableOfferTitle = themeStyles.apply(Copy, 'AvailableOfferTitle');
const OfferWrapper = themeStyles.apply(Box, 'OfferWrapper');
const AvailableOffer = ({ availableOffers, displayMode }) => {
    const { t } = useTranslation();
    if (!Array.isArray(availableOffers) || !(availableOffers === null || availableOffers === void 0 ? void 0 : availableOffers.length))
        return null;
    return (_jsxs(AvailableOfferContainer, { displayMode: displayMode, children: [_jsxs(AvailableOfferTitle, { size: "small", children: [t('Bonus offers'), _jsx(FloaterTooltipMarkdown, { as: "span", content: t('Stable offer tooltip content'), styling: "light", children: () => _jsx(Icon, { name: "information", filled: false }) })] }), availableOffers.map(({ key, description, offerSuperscript }) => (_jsxs(OfferWrapper, { children: [_jsx(SpecialOfferIcon, {}), _jsxs(Copy, { fontFamily: "bold", size: "extraSmall", children: [description, _jsx(Superscript, { ...offerSuperscript, ml: "xxs" })] })] }, key)))] }));
};
export default AvailableOffer;
